<template>
	<div class="first-access">
		<div class="container-phone" style="padding: 10vh 0;">
			<div class="pad-l">
				<div class="f-l f-bold c-primary" style="margin: 1em 0">Cambia la tua password</div>
				
				<div style="margin-top: 0.5em;">
					<form class="form" @submit.prevent="savePassword">
						<div class="p-relative">
							<input type="password" class="text-input" v-model="oldPwd" name="old-password" placeholder="Password attuale" autocomplete="current-password" required/>
							<div class="icon-md input-icon">lock</div>
						</div>

						<div class="p-relative">
							<input type="password" class="text-input" v-model="newPwd" name="new-password" placeholder="Nuova Password" autocomplete="new-password" required/>
							<div class="icon-md input-icon">lock</div>
						</div>

						<div class="p-relative">
							<input type="password" class="text-input" :class="{'error': repPwd.length && !checkPassword}" v-model="repPwd" name="repeat-password" placeholder="Conferma Nuova Password" autocomplete="repeat-password" required/>
							<div class="icon-md input-icon">lock</div>
						</div>

						<div style="margin: 0.5em 0;">
							<button type="input" class="submit-button">
								<LoadingWidget class="loading" :class="{hidden: !loading}"/>
								<span :class="{hidden: loading}">Salva Password</span>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import {notif} from '@/pop'

export default {
	name: 'first-access',

	data() {

		return {
			oldPwd: '',
			newPwd: '',
			repPwd: '',
			loading: false
		}
	},

	computed: {
		/**
		 * 
		 */
		checkPassword() {

			return this.newPwd === this.repPwd
		}
	},

	methods: {
		/**
		 * 
		 */
		async savePassword() {

			if (!this.checkPassword)
			{
				notif.error('Le Password immesse sono diverse.')
				return
			}

			// Show loading widget
			this.loading = true

			try
			{
				await api.auth().changePassword(this.oldPwd, this.newPwd)
				this.$router.push({name: 'dashboard'})
			}
			catch (err)
			{
				console.error(err.dev_msg || err)
				notif.error('Qualcosa è andato storto, riprova.')
			}
			finally
			{
				this.loading = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.form
	.text-input
		width 100%

		display block

		margin 0.5em 0
		padding 0.4em 0.6em
		border none
		outline-color primary
		box-sizing border-box

		background-color dark
		color lightish

		font-size 1.1em

		&:focus
			color light
		&.error
			background-color mix(dark, crimson, 80%)
			outline-color crimson
	
	.input-icon
		position absolute
		right 0.6em
		top 0.4em

		font-size 1.1em
	
	.reset-link
		color cadetblue

		text-decoration none

		&:hover
			text-decoration underline
	
	.submit-button
		width 100%

		display block

		position relative

		padding 0.4em 0.6em
		border none

		background-color primary
		color dark

		font-size: 1.2em

		transition height 0.2s ease

		&:hover
			background-color darken(primary, 2.5)

			cursor pointer
		&:focus
			outline none

		.loading
			width 1.8em
			height 1.8em

			position absolute
			top 50%
			left 50%

			color darkish

			transform translate(-50%, -50%)

			opacity 1

			transition 0.15s ease
		
			&.hidden
				opacity 0
		
		>span
			opacity 1

			transition 0.15s ease

			&.hidden
				opacity 0
</style>